export default __webpack_public_path__ + "locales/vi/ChangePasswordDialog.json?hash=101e0342576edc610ee5fda4127127ae";